module.exports = __webpack_public_path__ + "static/assets/9a61cf0144c57850ed385e5e9e505d27.png";